export enum StoreNames {
  LongSteelOrders = 'long_steel_orders'
}
